"use client";
import React from "react";
import { Box, Button, Heading, Highlight, Text, Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { FiArrowRight } from "@onemind-services-llc/react-icons-ng/fi";
import HeroImg from "public/about-us/hero-about.png";
import PageLayout from "@/layouts/pageLayout";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import { HERO_CONSTANTS } from "./constants";
import { BUTTON_VARIANTS } from "@/theme/components/button";

const HeroComp = () => {
  const { title, desc, btnText } = HERO_CONSTANTS;
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Box>
      <Box
        backgroundImage={HeroImg.src}
        backgroundPosition={"center"}
        backgroundSize={"cover"}
        color={"white"}
        py={{ base: 8, sm: 16 }}
        h={"auto"}
      >
        <PageLayout>
          <Stack spacing={8} width={{ base: "100%", md: "80%", xl: "70%" }}>
            <Heading as="h1" variant={HeadingVariant}>
              {title}
            </Heading>
            <Stack spacing={4}>
              {desc.map((item, index) => (
                <Text
                  key={index}
                  variant={TextVariant}
                  fontSize={{ base: "auto", lg: "20px" }}
                >
                  <Highlight
                    query={item.highlight}
                    styles={{ fontWeight: 700, color: "white" }}
                  >
                    {item.text}
                  </Highlight>
                </Text>
              ))}
            </Stack>
            <Button
              onClick={() => scrollToElement("contact-us", 120)}
              variant={BUTTON_VARIANTS.OUTLINE}
              rightIcon={<FiArrowRight />}
              w={"fit-content"}
            >
              {btnText}
            </Button>
          </Stack>
        </PageLayout>
      </Box>
    </Box>
  );
};

export default HeroComp;
